import { Image } from '@shared/components/image'
import styled from 'styled-components'

import { data } from './data'

export const View = () => {
	return (
		<Wrap>
			<Grid gap={40}>
				<Grid>
					<Title>Развивали цифровые решения для банков и технологии для клиентов</Title>
					<Text>
						В 2022 году мы привлекли 2 млн евро от известных бизнес-ангелов и текущих акционеров в
						ходе pre-series-А раунда. Так, благодаря команде и нашим технологиям, мы смогли
						завоевать доверие крупных инвесторов. Их деньги мы направили на развитие цифровых
						продуктов и масштабирование команды.
					</Text>
					<Text>
						В этом же году мы зарелизили приложение для заёмщиков и сберегателей «Credit.Club
						Деньги», чтобы нашими продуктами было ещё удобнее пользоваться.
					</Text>
				</Grid>
				<Grid>
					<Title>Вошли в реестр аккредитованных IT-компаний</Title>
					<Text>
						Теперь сотрудники Credit.Club могут пользоваться льготами: например, оформлять ипотеку с
						пониженной ставкой 5%.
					</Text>
				</Grid>
			</Grid>
			<Right>
				<Grid>
					<BigText>
						Открыли доступ к личному кабинету кредитора — в нём есть всё для быстрого запуска
						залогового кредитования в банке и любой другой финансовой организации.
					</BigText>
					<Text>
						Если кредитору нужно запустить нецелевую ипотеку с нуля, он просто регистрируется в
						личном кабинете, подписывает документы — и готово. Остальное берём на себя мы и наши
						технологии.
					</Text>
					<Link href={data.card.link.href} target='_blank' rel='noopener noreferrer nofollow'>
						Узнать о платформе
					</Link>
					<Image name='lender-ui.png' alt='lender-ui' />
				</Grid>
			</Right>
		</Wrap>
	)
}

const Wrap = styled.article(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: '1fr',
	gap: 30,

	[theme.mediaQueries.mediaMinWidthTablet]: {
		gridTemplateColumns: '1fr 1fr',
	},
}))

const Right = styled.div(({ theme }) => ({
	background: '#D7F9EA',
	borderRadius: 16,
	padding: 24,
	boxShadow:
		'0px 1.197px 0px 0px rgba(0, 0, 0, 0.01), 0px 4.021px 6.38px 0px rgba(0, 0, 0, 0.03), 0px 18px 65px 0px rgba(0, 0, 0, 0.07);',
}))

const Grid = styled.div<{ gap?: number }>(({ theme, gap = 24 }) => ({
	display: 'grid',
	gap: gap,
	gridTemplateColumns: '1fr',
}))

const Title = styled.div(({ theme }) => ({
	lineHeight: '40px',
	fontSize: '32px',
	fontWeight: 800,
}))

const Text = styled.div(({ theme }) => ({
	lineHeight: '28px',
	fontSize: '20px',
}))

const Link = styled.a(({ theme }) => ({
	lineHeight: '28px',
	color: theme.colors.main,
	fontSize: '20px',
}))

const BigText = styled.div(({ theme }) => ({
	fontSize: '28px',
	lineHeight: '32px',
	fontWeight: 700,
}))
